import { useEffect, useState } from 'react';
import axios from 'axios';
import { FlaskConical } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CHECKOUT_PATHS = ['/create-checkout', '/orders/mine/upgrade', '/upgrade-offer/checkout'];

// Lets the backend recognise the admin's own browser for practice checkouts.
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token && config.url?.startsWith(API) && CHECKOUT_PATHS.some((p) => config.url.includes(p))) {
    config.headers = { ...config.headers, 'X-Practice-Admin': token };
  }
  return config;
});

export const practiceEndsAt = (iso) => new Date(iso).toLocaleTimeString('en-AU', { hour: 'numeric', minute: '2-digit' });

export const PracticeBanner = () => {
  const [until, setUntil] = useState(null);
  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (!token) return;
    axios.get(`${API}/admin/practice-mode`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setUntil(r.data.active ? r.data.until : null)).catch(() => {});
  }, []);
  if (!until) return null;
  return (
    <div className="fixed bottom-4 left-4 z-[60] max-w-[calc(100vw-2rem)] px-4 py-2.5 rounded-2xl bg-[#C5A059] text-[#1E1622] shadow-xl text-xs sm:text-sm font-semibold inline-flex items-center gap-2" data-testid="practice-mode-banner">
      <FlaskConical size={16} /> Practice mode: no real money. Checkouts use test payments until {practiceEndsAt(until)}.
    </div>
  );
};
